import { createWebHistory, createRouter,createWebHashHistory } from 'vue-router'

import HomeView from '@/views/Home.vue'
import LoginView from '@/views/authentication/Login.vue'
import BatchView from '@/views/batches/index.vue'
import BillView from '@/views/bills/index.vue'
import GSTView from '@/views/gst/index.vue'
import ErrorView from '@/components/ErrorScreen.vue'
import PurchaseView from '@/views/purchase/index.vue'
import StockView from '@/views/stock/index.vue'
import PartyLedgerView from '@/views/partyledger/index.vue'
import { useAuthStore } from '@/stores/AuthStore'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/error', name: 'error', component: ErrorView },
  { path: '/login', name: 'login', component: LoginView },
  { path: '/batches', name: 'batches', component: BatchView, meta: {role: 's_create-bill', }, beforeEnter: [checkAuthorization] },
  { path: '/gst', name: 'gst', component: GSTView, meta: {role: 's_create-bill', }, beforeEnter: [checkAuthorization] },
  { path: '/bills', name: 'bills', component: BillView, meta: {role: 's_create-bill', }, beforeEnter: [checkAuthorization] },
  { path: '/purchase', name: 'purchase', component: PurchaseView, meta: {role: 's_create-bill', }, beforeEnter: [checkAuthorization] },
  { path: '/stock', name: 'stock', component: StockView, meta: {role: 's_create-bill', }, beforeEnter: [checkAuthorization] },
  { path: '/partyledger', name: 'partyledger', component: PartyLedgerView, meta: {role: 's_create-bill', }, beforeEnter: [checkAuthorization] },
]

const router = createRouter({
  //history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes,
})

function checkAuthorization(to) {
  const authStore = useAuthStore()
  if (!authStore.roles.includes(to.meta.role)) return '/error'
  
}

router.beforeEach((to) => {
  const authStore = useAuthStore()
  // ✅ This will work because the router starts its navigation after
  // the router is installed and pinia will be installed too
  if (to.name !== 'login' && !authStore.isUserLoggedIn) return '/login'
})

export default router